import React from 'react'
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { COLORS } from "../../utils/Colors";

interface AppHeaderProps {
  toggleSidebar: () => void
}

const AppHeader: React.FC<AppHeaderProps> = ({ toggleSidebar }) => {
  return (
    <>
      <button className="" onClick={toggleSidebar}>
        <FontAwesomeIcon className="w-8 h-8" color={COLORS.Disabled} icon={faBars} />
      </button>
    </>
  )
}

export default AppHeader